import _ from 'lodash'

/**
 * 
 * @param {object} pathViews 
 * @param {array} items 
 * @returns the path at the CLIENT collection level - client/clientKey/events/eventKey from pathViews
 */
export const createRefPath_client = (pathViews, items) => {
  let path = ''
  if (pathViews.clients) {
    path = 'clients/' + pathViews.clients
    if (items) { path += '/' + createRefPath(items) }
  }
  return path
}

/**
 * 
 * @param {object} pathViews 
 * @param {array} items - additional paths
 * @returns the path at the EVENT collection level - client/clientKey/events/eventKey from pathViews
 */
export const createRefPath_eventXX = (pathViews, items, forBackup, forDb) => {
  let path = ''
  if (pathViews.clients && pathViews.events) {
    path = 'clients/' + pathViews.clients + '/events/' + pathViews.events
    if (forBackup) { path += '_backup' }
    if (items) { path += '/' + createRefPath(items) }
  }
  return path
}

export const createRefPath_event = (pathViews, items, forBackup, forDb) => {
  if (!pathViews.clients || !pathViews.events) return '';

  const basePath = `clients/${pathViews.clients}/events/${pathViews.events}`;
  const backupPath = forBackup ? '_backup' : '';
  const itemsPath = items ? `/${createRefPath(items)}` : '';

  return `${basePath}${backupPath}${itemsPath}`;
};

/** client/clientKey/events from pathViews; eventKey passed in */
export const createRefPath_events = (pathViews, eventKey, items) => {
  let path = ''
  if (pathViews.clients && eventKey) {
    path = 'clients/' + pathViews.clients + '/events/' + eventKey
    if (items) { path += '/' + createRefPath(items) }
  }
  return path
}

export const createRefPath_any = (pathViews, items, eventKey) => {
  let path = ''
  if (pathViews.clients) {
    path = 'clients/' + pathViews.clients
    if (pathViews.events) {
      path += '/events/' + pathViews.events
    } else if (eventKey) {
      path += '/events/' + pathViews.events
    }
    if (items) { path += '/' + createRefPath(items) }
  }
  return path
}


/**
 *  
 * @param {array} items - path items
 * @param {string} existing - an existing path that will proceed the items
 * @returns the path
 */
export const createRefPath = (items, existing) => {
  const path = _.isArray(items) && items.length ? items.join('/') : '/'
  return existing ? `${existing}/${path}` : path;
};

/** client/clientKey/events from pathViews; eventKey passed in */
export const createStoragePath_events = (pathViews, items) => {
  let path = ''
  if (pathViews.clients && pathViews.events) {
    path = 'clients/' + pathViews.clients + '/events/' + pathViews.events
    if (items) { path += '/' + createRefPath(items) }
  }
  return path
}